import React, { useEffect } from 'react';

// Sostituisce gli alert() sparsi ovunque, ed e il canale con cui arrivano
// all'utente i rifiuti del server: prima ogni comando rifiutato usciva in
// silenzio e l'interfaccia sembrava semplicemente bloccata.

// I livelli arrivano dal socket come 'error' | 'success' | 'info': li si
// traduce qui nella semantica visiva condivisa (stop/go/info) senza toccare
// il payload che gli hook gia emettono altrove.
const LEVEL_VARIANT = { error: 'stop', success: 'go' };

function Toast({ message, onDismiss }) {
    useEffect(() => {
        const handle = setTimeout(() => onDismiss(message.id), 6000);
        return () => clearTimeout(handle);
    }, [message.id, onDismiss]);

    const variant = LEVEL_VARIANT[message.level] ?? 'info';

    return (
        <div className={`toast toast--${variant}`} role="status">
            <span>{message.text}</span>
            <button
                type="button"
                className="toast-close"
                aria-label="Chiudi"
                onClick={() => onDismiss(message.id)}
            >
                &times;
            </button>
        </div>
    );
}

export default function Toasts({ messages, onDismiss }) {
    if (!messages?.length) return null;
    return (
        <div className="toast-stack">
            {messages.map((message) => (
                <Toast key={message.id} message={message} onDismiss={onDismiss} />
            ))}
        </div>
    );
}
